import { useCallback } from "react"
import { useAvatar } from "./useAvatar";
import { useGlobalContext } from "../context/useGlobalContext";
import { useProfile } from "./useTypeProfile";
import { changeAvatar } from "../services/userService"

export const useUser = () => {
    const { avatar, setAvatar } = useGlobalContext();
    const { getAvatar } = useAvatar();
    const { getTypeRole, getProfileId, getTypeRoleUser } = useProfile();
    const type = getTypeRole();
    const typeUser = getTypeRoleUser();
    const isOwner = type === "owner" || typeUser === "owner";
    const isAlmacen = type === "almacen" || typeUser === "almacen" || isOwner;
    const isHost = type === "host";
    const isResto = type === "resto" || isOwner || isAlmacen;
    const isAtm = typeUser === "atm";
    const isAdminFGS = type === "admin-fgs";
    const isCEO = typeUser === "ceo";
    const userId = getProfileId();

    const getAvatarUser = useCallback(async (cover, name) => {
        const src = await getAvatar(cover, name || "");
        setAvatar(src);
    }, [getAvatar, setAvatar])

    const imageUpload = async (file) => {
        await changeAvatar(file, typeUser === "ceo" ? "ceo" : type);
    }

    return {
        type,
        userId,
        isHost,
        isResto,
        isAtm,
        isOwner,
        isAdminFGS,
        isCEO,
        isAlmacen,
        avatar,
        getAvatarUser,
        imageUpload
    }
}
